import type {
  AddEditClinicianRequestT,
  ClinicianRoleTypeT,
  DoseSpotClinicianInfoT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { formatPhoneNumber } from '@/shared/lib/formatters';

import { toMdy } from './date-of-birth';
import { LOTUS_OFFICE_DEFAULTS } from './lotus-office-defaults';

const CLINICIAN_ROLE_VALUES = new Set<ClinicianRoleTypeT>(['1', '2', '3', '4', '5', '6']);

function toClinicianRoleTypes(roles: DoseSpotClinicianInfoT['Roles']): ClinicianRoleTypeT[] {
  if (!Array.isArray(roles)) return [];
  return roles.filter((r): r is ClinicianRoleTypeT =>
    CLINICIAN_ROLE_VALUES.has(r as ClinicianRoleTypeT)
  );
}

export function createEmptyClinicianInfo(): AddEditClinicianRequestT {
  return {
    ...LOTUS_OFFICE_DEFAULTS,
    DateOfBirth: '',
    FirstName: '',
    LastName: '',
    NPINumber: '',
    ClinicianRoleType: ['1'],
  };
}

export function clinicianInfoFromDoseSpot(
  info: DoseSpotClinicianInfoT | null
): AddEditClinicianRequestT {
  if (!info) return createEmptyClinicianInfo();
  const clinicianRoleTypes = toClinicianRoleTypes(info.Roles);

  return {
    ...LOTUS_OFFICE_DEFAULTS,
    DateOfBirth: toMdy(info.DateOfBirth ?? ''),
    FirstName: info.FirstName ?? '',
    LastName: info.LastName ?? '',
    NPINumber: info.NPINumber ?? '',
    PrimaryPhone: formatPhoneNumber(info.PrimaryPhone),
    ClinicianRoleType: clinicianRoleTypes.length > 0 ? clinicianRoleTypes : ['1'],
  };
}
